
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Counts from "./counts";
import PieCount from "./pieCount";
import BarYearCount from "./barCountByYear";
import BarMonthCount from "./barCountByMonth";

const AnalyticsTabs = () => {

    const [activeTab, setActiveTab] = useState("");

    const tabData = [
        {
            name: "",
            content: <Counts />
        },
        {
            name: "Institute Count Percentage By Sport",
            content: <PieCount />
        },
        {
            name: "Institute Count by Year",
            content: <BarYearCount />
        },
        {
            name: "Sessions Count by Quarter and Month",
            content: <BarMonthCount />
        },
        {
            name: "Sessions Count by Week",
            content: null
        }
    ]
    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">Analytics</h3>
                            </div>
                            <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link
                                                        to="#"
                                                        className={tab.name === activeTab ? "active" : ""}
                                                        onClick={() => setActiveTab(tab.name)}
                                                    >
                                                        {tab.icon} {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    {tabData
                                        .filter(tab => tab.name === activeTab)
                                        .map((tab, i) => (
                                            <div key={i}>{tab.content}</div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AnalyticsTabs;